export const PASSWORD = 'password';
export const FACEBOOK = 'facebook';
export const GOOGLE = 'google';



// WEBPACK FOOTER //
// ./src/constants/signupProviders.js